import LicenseInfo from "./LicenseInfo";
import ContactPanel from "./ContactPanel";
import { Box } from "@mui/material";

const Contact = () => {
    return (
        <Box mt="5%">
            <ContactPanel />
            <Box position="absolute" bottom={0} width="100%">
                <LicenseInfo />
            </Box>
        </Box>
    );
};

export default Contact;
